/**
 * Drag Overlay Block
 * Visual preview shown during drag operations
 */

import React from 'react';
import type { BlockDefinition } from './BlockPalettePanel';

interface DragOverlayBlockProps {
  definition: BlockDefinition;
}

export function DragOverlayBlock({ definition }: DragOverlayBlockProps) {
  return (
    <div className="bg-white border-2 border-blue-400 rounded-lg shadow-xl px-4 py-3 flex items-center gap-3 w-56 opacity-90">
      <span className="text-xl">{definition.icon}</span>
      <div>
        <span className="text-sm font-medium text-gray-800">{definition.label}</span>
        <span className="block text-xs text-gray-500">{definition.category}</span>
      </div>
    </div>
  );
}
